var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:[
      {'has-label': _vm.label || _vm.$slots.label},
      { focused: _vm.focused }
    ]},[_vm._t("label",[(_vm.label)?_c('label',{staticClass:"form-control-label",class:_vm.labelClasses},[_vm._v("\n        "+_vm._s(_vm.label)+"\n        "),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]):_vm._e()]),_vm._t("default",[_c('textarea',_vm._g(_vm._b({staticClass:"form-control",class:[_vm.inputClasses],style:([
          { resize: _vm.noResize ? 'none' : 'vertical' }
        ]),domProps:{"value":_vm.value}},'textarea',_vm.$attrs,false),_vm.listeners))],null,_vm.slotData)],2)}
var staticRenderFns = []

export { render, staticRenderFns }